import _ from 'lodash'
import React, { useState } from 'react'
import useError from '@vero/ui-core-browser/hooks/error.js'
import useRedirectParam from '@vero/ui-core-browser/hooks/redirect-param.js'
import useSubmit from '@vero/ui-core-browser/hooks/submit.js'
import Input from '@vero/ui-components/components/input.jsx'
import HeaderWithVero from '@vero/ui-components/components/header-with-vero.jsx'
import useClaims from '../hooks/claims.js'
import useEmail from '../hooks/email.js'
import useProviders from '../hooks/providers.js'
import EmailInput from '../components/email-input.jsx'
import Providers from '../components/providers.jsx'
import SubmitButton from '../components/submit-button.jsx'

export default function ({ title, className }) {
  const { redirect } = useRedirectParam()

  const [loading, setLoading] = useState(false)
  const { error, setError, handleError } = useError()
  const { email, setEmail, clearEmail } = useEmail()
  const { providers, hasEmailProvider } = useProviders(email, setLoading, setError, handleError)
  const [password, setPassword] = useState('')
  const { authClient, storeTokens } = useClaims()

  const onSubmit = useSubmit(setLoading, setError, handleError, async () => {
    if (!_.isEmpty(providers) && email && password) {
      await storeTokens(await authClient.login(email, password), redirect)
    }
  })

  return (
    <div className={className}>
      {error && <div className='alert alert-error'>{error}</div>}

      <div className='p-8'>
        <HeaderWithVero title={title} />

        <form onSubmit={onSubmit} className='mb-6'>
          <div className='flex flex-col gap-4'>
            <EmailInput
              className='grow'
              value={email}
              onChange={e => {
                setError(null)
                setEmail(e?.target?.value)
              }}
              onClear={() => {
                setError(null)
                clearEmail()
                setPassword('')
              }}
              required
            />

            {hasEmailProvider() && (
              <>
                <Input
                  type='password'
                  name='password'
                  label='password'
                  className='grow'
                  autoComplete='current-password'
                  value={password}
                  onChange={e => {
                    setError(null)
                    setPassword(e.target.value)
                  }}
                  required
                />

                <a
                  href={`/auth/reset-password?r=${redirect}`}
                  className='link link-secondary capitalize text-sm self-end'
                >
                  forgot password?
                </a>
              </>
            )}

            <div className='flex flex-col gap-2'>
              {(_.isEmpty(providers) || hasEmailProvider()) && (
                <div className='flex flex-col'>
                  <SubmitButton title={title} loading={loading} />
                </div>
              )}

              <Providers providers={providers} />
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}
